import React, { Component } from "react";

import { Row, Col, Card, CardImg, CardTitle } from "reactstrap";
import Swiper from "react-id-swiper";
import StarRatingComponent from "react-star-rating-component";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { isGamiclub } from "../../constants/isGamiclub";
import { isGameflares, isGamiway } from "../../constants/productCondition";
import { withRouter } from "react-router-dom"

class CategoryGamesDemo extends Component {
  constructor(props) {
    super(props);
    this.shuffle = this.shuffle.bind(this);
    this.arrayMove = this.arrayMove.bind(this);
    this.doAction = this.doAction.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  shuffle(gameArray) {
    var shuffledArray = gameArray.sort(() => Math.random() - 0.5);
    return shuffledArray;
  }

  arrayMove(arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }

  doAction(game, gameIndex) {
    if ((gameIndex === 0 || gameIndex === 1) && (game.categoryName === "New Arrivals" || game.categoryName === "Inspiration")) window.location.href = "#/play-maxis/" + game.gameId;
    else window.location.href = "#/subscription-maxis/";
  }

  render() {
    const { category } = this.props;

    const gamesParams = {
      direction: "horizontal",
      slidesPerView: "auto",
      speed: 500,
    };

    var gameRelatedMoreClass = "game-related-more";
    var gameCategoryTitleClass = "game-category-title";

    return (
      <div>
        <Row>
          <Col xs="12" className="game-related-container">
            <div className="game-related-top">
              <div
                className="game-category"
                style={
                  isGamiclub
                    ? { borderBottom: "1px solid green" }
                    : isGameflares
                    ? { borderBottom: "1px solid #FF394B" }
                    : isGamiway
                    ? { borderBottom: "1px solid #b347a0" }
                    : null
                }
              >
                <h2
                  style={
                    isGamiclub
                      ? { color: "white", backgroundColor: "green" }
                      : isGameflares
                      ? { color: "white", backgroundColor: "#FF394B" }
                      : isGamiway
                      ? { color: "white", backgroundColor: "#b347a0" }
                      : null
                  }
                  className={gameCategoryTitleClass}
                >
                  <i
                    className={this.props.category.categoryIcon}
                    aria-hidden="true"
                  ></i>
                  <FormattedMessage
                    id={`${category.categoryName}`}
                    defaultMessage={category.categoryName}
                  />
                </h2>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="game-list-row">
          {this.props.games.length > 0 ? (
            <Col xs="12">
              <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                {this.shuffle(this.props.games).map((game, gameIndex) => {
                  return (
                    <div className="swiper-game-card" key={game.gameId}>
                      <Card
                        className={
                          isGamiclub
                            ? "game-card-gamiclub"
                            : isGameflares
                            ? "game-card gameflares-card-hover"
                            : isGamiway
                            ? "game-card gamiway-card"
                            : "game-card"
                        }
                        onClick={this.doAction.bind(this, game, gameIndex)}
                      >
                        <div className="game-card-inner">
                          <div className="game-thumb-wrap">
                            <CardImg
                              className="game-thumb"
                              top
                              width="100%"
                              src={
                                game.gameImage.includes(
                                  "https://cdn.game-lords.com/games/http"
                                )
                                  ? game.gameImage.split(
                                      "https://cdn.game-lords.com/games/"
                                    )[1]
                                  : game.gameImage
                              }
                              alt={game.gameTitle}
                            />
                          </div>
                          <div className="game-card-details">
                            <CardTitle className="game-title text-shadow">
                              <FormattedMessage
                                id={`${game.gameTitle.toUpperCase()}`}
                                defaultMessage={game.gameTitle}
                              />
                            </CardTitle>

                            <div className="game-card-left">
                              <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={game.userRating}
                                editing={false}
                                renderStarIcon={() => (
                                  <i
                                    style={
                                      isGamiclub
                                        ? { color: "green" }
                                        : isGameflares
                                        ? { color: "#FF394B" }
                                        : isGamiway
                                        ? { color: "#b347a0" }
                                        : null
                                    }
                                    className="fa fa-star custom-star"
                                  ></i>
                                )}
                              />
                            </div>

                            <div className="game-card-right text-uppercase text-shadow text-right">
                              <i
                                className={
                                  (gameIndex === 0 || gameIndex === 1) && (game.categoryName === "New Arrivals" || game.categoryName === "Inspiration")
                                    ? "fa fa-unlock"
                                    : "fa fa-lock"
                                }
                                aria-hidden="true"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </div>
                  );
                })}
              </Swiper>
            </Col>
          ) : (
            <Col xl="12" lg="12" md="12" sm="12" xs="12">
              <p className="white-text-color">
                <FormattedMessage
                  id="noGamesFound"
                  defaultMessage="No games found under this category."
                />
              </p>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
  };
};

export default connect(mapStateToProps)(CategoryGamesDemo);


// WEBPACK FOOTER //
// ./src/components/CategoryGames/CategoryGamesDemo.js